import { LIST_LOAD_REQUEST, LIST_LOAD_SUCCESS, LIST_LOAD_FAILURE } from '../types/login-types';

const initialState = {
  loading: false,
  error: null,
  data: null
};

function login(state = initialState, action: any = null) {
  switch (action.type) {
    case LIST_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LIST_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case LIST_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    default:
      return state;
  }
}

export default login;
